export { default } from './NotFound'